import React, { useContext, useEffect, useState } from 'react'
import ContentHeader from '@Components/ContentHeader'
import SongwriterCatalogBuilderResults from '@Scenes/SongwriterScene/SongwriterCatalogBuilderScene/SongwriterCatalogBuilderResults'
import { StoresContext } from '@App/contexts'
import SongwriterMyWritersHeader from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterMyWritersHeader'
import SongwriterMyWritersTable from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterMyWritersTable'
import { observer } from 'mobx-react'
import SearchByParty from '@Components/Search/SearchByParty'
import Sidebar from '@Components/Sidebars/Sidebar'
import SongwriterRequestUpdateSidebar from '@Scenes/SongwriterScene/SongwriterMyWritersScene/SongwriterRequestUpdateSidebar'
import ModalPortal from '@Components/Popups/ModalPortal'
import { SearchResultPartyDetails } from '@Entities/party-details'
import SearchResultPartyDetailsCard from '@Components/Search/SearchByParty/SearchResultPartyDetailsCard'

const SongwriterMyWritersScene = () => {
    const { songwriterMyWriterSearchStore, preloaderStore } = useContext(StoresContext)
    const [selectedWriter, setSelectedWriter] = useState<SearchResultPartyDetails | null>(null)

    useEffect(() => {
        preloaderStore.openTransparentPreloader(true)
        songwriterMyWriterSearchStore.search().finally(() => preloaderStore.openTransparentPreloader(false))
        return () => {
            songwriterMyWriterSearchStore.resetStore()
        }
    }, [])

    const onWriterToggle = React.useCallback(
        async (isLinked: boolean, writerIpId: number) => {
            await songwriterMyWriterSearchStore.toggleSongwriterLink(isLinked, writerIpId)
        },
        [songwriterMyWriterSearchStore]
    )

    const linkedWriterIpIdSet = React.useMemo(
        () => new Set(songwriterMyWriterSearchStore.linkedSongwriters.map((writer) => writer.affWriterIpId)),
        [songwriterMyWriterSearchStore.linkedSongwriters.length]
    )

    return (
        <>
            <title>My Writer Names</title>
            <ModalPortal isOpen={!!selectedWriter} onClose={() => setSelectedWriter(null)}>
                {selectedWriter && (
                    <Sidebar onClose={() => setSelectedWriter(null)}>
                        <SongwriterRequestUpdateSidebar
                            selectedWriterName={selectedWriter.name}
                            selectedWriterIpId={Number(selectedWriter.ipId)}
                            selectedWriterIpiNumber={selectedWriter.ipiNumber ?? undefined}
                            writers={songwriterMyWriterSearchStore.searchResults}
                            closeSidebar={() => setSelectedWriter(null)}
                        />
                    </Sidebar>
                )}
            </ModalPortal>
            <div className="songwriter-link-wrapper">
                <ContentHeader title="My Writer Names" content={<SongwriterMyWritersHeader />} />
                <div className="songwriter-writer-search">
                    <SearchByParty
                        searchPartyStore={songwriterMyWriterSearchStore}
                        renderPartyResultsTable={(onTitleClick, setLoading) => (
                            <SongwriterCatalogBuilderResults
                                setLoading={setLoading}
                                songwriterWriterSearchStore={songwriterMyWriterSearchStore}
                            >
                                <SongwriterMyWritersTable
                                    data={songwriterMyWriterSearchStore.searchResults}
                                    onTitleClick={onTitleClick}
                                    linkedWriterIpIds={linkedWriterIpIdSet}
                                    onWriterToggle={onWriterToggle}
                                    requestAnUpdate={(newSelectedWriter: SearchResultPartyDetails) => {
                                        setSelectedWriter(newSelectedWriter)
                                    }}
                                />
                            </SongwriterCatalogBuilderResults>
                        )}
                        partyDetailsCardComponent={SearchResultPartyDetailsCard}
                    />
                </div>
            </div>
        </>
    )
}

export default observer(SongwriterMyWritersScene)
